import { Beans } from 'ag-grid-community';
import { createContext } from "solid-js";

export const BeansContext = createContext<Beans>({} as Beans);
